import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { CAMPAIGN_TYPES } from '../constants/campaign';

/**
 * Composable to manage campaign types based on current route.
 * @returns {Object} Computed properties for campaign type and helpers.
 */
export const useCampaign = () => {
  const route = useRoute();

  const campaignType = computed(() => {
    const campaignTypeMap = {
      one_off: CAMPAIGN_TYPES.ONE_OFF,
      campaigns_whatsapp_index: CAMPAIGN_TYPES.ONE_OFF,
    };
    return campaignTypeMap[route.name];
  });

  const isOngoingType = computed(() => {
    return campaignType.value === CAMPAIGN_TYPES.ONGOING;
  });

  const isOneOffType = computed(() => {
    return campaignType.value === CAMPAIGN_TYPES.ONE_OFF;
  });

  return {
    campaignType,
    isOngoingType,
    isOneOffType,
  };
};
